var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMan(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 188.149 188.149",
    style: {
      enableBackground: "new 0 0 188.149 188.149"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 94.074,
    cy: 94.075,
    r: 94.074
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "#E6E7E2"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#ECC19C"
    },
    d: "M126.708,153.946h-0.02c-2.041-1.545-4.178-2.919-6.429-4.159 c-0.058-0.038-0.115-0.076-0.191-0.095c-10.646-5.876-17.857-17.209-17.857-30.239l-16.121-0.077 c0,13.069-7.269,24.459-18.01,30.315c0,0-0.019,0-0.038,0.019c-2.271,1.24-4.445,2.633-6.506,4.159 c-13.355,9.94-21.997,25.832-21.997,43.766h109.07C148.61,179.74,140.006,163.885,126.708,153.946z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#168EF7"
    },
    d: "M148.609,197.629H39.538c0-17.934,8.642-33.826,21.997-43.766 c2.061-1.526,4.235-2.919,6.505-4.159c0.02-0.019,0.039-0.019,0.039-0.019c1.755-0.973,3.434-2.08,4.979-3.339 c5.342,5.476,12.802,8.872,21.063,8.872c8.242,0,15.683-3.396,21.024-8.853c1.526,1.259,3.187,2.366,4.922,3.32 c0.076,0.019,0.134,0.057,0.191,0.095c2.251,1.24,4.388,2.614,6.429,4.159h0.02C140.005,163.879,148.609,179.733,148.609,197.629z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#ECC19C"
    },
    d: "M52.217,38.091v42.836c0,28.976,25.437,52.465,41.858,52.465 c16.419,0,41.858-23.489,41.858-52.465V38.091H52.217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#494846"
    },
    d: "M129.114,30.207c-9.123-11.423-22.972-18.726-38.463-18.726 c-27.521,0-49.81,22.972-49.81,51.301c0,15.036,6.267,28.556,16.274,37.932c-2.578-6.47-4.018-13.722-4.018-21.38 c0-12.307,3.74-23.578,9.957-32.246c6.596,2.932,17.286,3.993,29.011,2.376c11.625-1.592,21.531-5.433,27.116-10.007 c10.185,8.996,16.806,23.502,16.806,39.877c0,8.39-1.719,16.275-4.802,23.199c9.83-4.069,17.058-18.574,17.058-35.835 C148.243,48.225,139.954,32.987,129.114,30.207z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMan);
export default __webpack_public_path__ + "static/media/man.16e5c9616c8461e11d4a06240e9f1a39.svg";
export { ForwardRef as ReactComponent };